import { lazy } from "react";
import paths from "../paths";
import { withPageWrapper } from "components/PageWrapper";

const NonAuth = lazy(() => import("pages/NonAuth/index").then(module => ({ default: module.NonAuth })));
// const NonAuthPayment = lazy(() =>
//   import("pages/NonAuthPayment/index").then(module => ({ default: module.NonAuthPayment }))
// );
const Purchase = lazy(() => import("pages/Purchase").then(module => ({ default: module.Purchase })));

export const nonAuthRoutes = [
  { path: paths.nonAuth.search, Component: withPageWrapper(NonAuth), app: false },
  { path: paths.nonAuth.payment, Component: withPageWrapper(Purchase), app: false }
];
